export default {
  article_details: "Artikeldetails",
  asset_details: "Assetdetails",
  request_details: "Anfragedetails",
  new_customer_request: "Neue Kundenanfrage",
  assign_amount: "Betrag zuordnen ",
};
